import { GET_PERSONALIZATION_CONTENT_REQUEST } from './constants';

export const getPersonalizationBlock = (code) => ({
  type: GET_PERSONALIZATION_CONTENT_REQUEST,
  code
});
